import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/locking-list',
    name: 'LockingList',
    component: () => import('../views/LockingList.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/HelpView.vue')
  },
  {
    path: '/copy-trading',
    name: 'copy-trading',
    component: () => import('../views/CopyTrading.vue')
  },
  {
    path: '/launchpad-list',
    name: 'launchpad-list',
    component: () => import('../views/LaunchpadList.vue')
  },
  {
    path: '/launchpool',
    name: 'launchpool',
    component: () => import('../views/LaunchpoolView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: () => import('../views/ProtocolView.vue')
  },
  {
    path: '/usd-btc',
    name: 'usd-btc',
    component: () => import('../views/UsdBtc.vue')
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/ShowView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  next()
});

export default router
